export class EmailAttachment extends Object {

    /**
     * Attachment file name
     * @type {string}
     */
    name = '';

    /**
     * Base64 data
     * @type {string}
     */
    data = '';
}



// WEBPACK FOOTER //
// /app/src/model/Entities/EmailAttachment.ts